/* Bubbly: adicionar ao carrinho nas listas de produtos (snippets/bubbly-quick-add.liquid) */
(function () {
  if (customElements.get('bubbly-quick-add')) return;

  // Textos no idioma da página (window.bubblyTextos, definido em layout/theme.liquid); português por omissão
  function tx(chave, pt) {
    return (window.bubblyTextos && window.bubblyTextos[chave]) || pt;
  }

  var anuncio;
  function anunciar(texto) {
    if (!anuncio) {
      anuncio = document.createElement('div');
      anuncio.className = 'visually-hidden';
      anuncio.setAttribute('role', 'status');
      anuncio.setAttribute('aria-live', 'polite');
      document.body.appendChild(anuncio);
    }
    anuncio.textContent = '';
    setTimeout(function () {
      anuncio.textContent = texto;
    }, 50);
  }

  // Carrinho lateral: atualiza o conteúdo sem o abrir (abrir a cada artigo interrompe quem está a juntar vários).
  // Em vez disso aparece um aviso leve em baixo (mostrarAviso), com "Finalizar compra" e "Ver carrinho".
  function atualizarCarrinhoLateral(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections || !sections['cart-drawer']) return;
    var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var novo = html.querySelector('#CartDrawer');
    var atual = document.getElementById('CartDrawer');
    if (novo && atual) atual.innerHTML = novo.innerHTML;
    drawer.classList.remove('is-empty');
  }

  function atualizarIconeCarrinho(sections) {
    var icone = document.getElementById('cart-icon-bubble');
    if (!icone) return;
    if (sections && sections['cart-icon-bubble']) {
      var html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var novo = html.querySelector('.shopify-section');
      if (novo) icone.innerHTML = novo.innerHTML;
    }
    icone.classList.remove('bubbly-qa-bump');
    void icone.offsetWidth; // reinicia a animação
    icone.classList.add('bubbly-qa-bump');
  }

  // Aviso leve depois de adicionar (26/10): miniatura, nome e dois caminhos (finalizar / ver carrinho). Fica 6 s, fecha com
  // um toque e não tapa a página; com o aviso visível, os selos flutuantes escondem-se (snippets/bubbly-ecra-limpo.liquid).
  var aviso, avisoTempo;
  function mostrarAviso(item) {
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'bubbly-qa-aviso';
      aviso.setAttribute('role', 'status');
      aviso.innerHTML =
        '<div class="bubbly-qa-aviso__topo">' +
        '<img class="bubbly-qa-aviso__img" alt="" width="48" height="48" hidden>' +
        '<div class="bubbly-qa-aviso__texto"><p class="bubbly-qa-aviso__titulo"></p><p class="bubbly-qa-aviso__nome"></p></div>' +
        '<button type="button" class="bubbly-qa-aviso__fechar">&times;</button>' +
        '</div>' +
        '<div class="bubbly-qa-aviso__acoes">' +
        '<a class="button bubbly-qa-aviso__finalizar"></a>' +
        '<a class="button button--secondary bubbly-qa-aviso__ver"></a>' +
        '</div>';
      document.body.appendChild(aviso);
      aviso.querySelector('.bubbly-qa-aviso__fechar').addEventListener('click', esconderAviso);
      aviso.addEventListener('mouseenter', function () { clearTimeout(avisoTempo); });
      aviso.addEventListener('focusin', function () { clearTimeout(avisoTempo); });
    }
    aviso.querySelector('.bubbly-qa-aviso__titulo').textContent = '✓ ' + tx('avisoAdicionado', 'Adicionado ao carrinho');
    aviso.querySelector('.bubbly-qa-aviso__nome').textContent = (item && item.product_title) || '';
    var img = aviso.querySelector('.bubbly-qa-aviso__img');
    var src = item && ((item.featured_image && item.featured_image.url) || item.image);
    if (src) {
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
      img.hidden = false;
    } else {
      img.hidden = true;
    }
    var fin = aviso.querySelector('.bubbly-qa-aviso__finalizar');
    fin.href = raiz + 'checkout';
    fin.textContent = tx('avisoFinalizar', 'Finalizar compra');
    var ver = aviso.querySelector('.bubbly-qa-aviso__ver');
    ver.href = raiz + 'cart';
    ver.textContent = tx('avisoVer', 'Ver carrinho');
    aviso.querySelector('.bubbly-qa-aviso__fechar').setAttribute('aria-label', tx('avisoFecharCarrinho', 'Fechar'));
    aviso.classList.add('is-visivel');
    clearTimeout(avisoTempo);
    avisoTempo = setTimeout(esconderAviso, 6000);
  }
  function esconderAviso() {
    clearTimeout(avisoTempo);
    if (aviso) aviso.classList.remove('is-visivel');
  }

  customElements.define(
    'bubbly-quick-add',
    class extends HTMLElement {
      connectedCallback() {
        this.botao = this.querySelector('button');
        this.texto = this.querySelector('[data-texto]');
        this.textoOriginal = this.texto ? this.texto.textContent : '';
        this.botao.addEventListener('click', this.adicionar.bind(this));
      }

      estado(nome, texto) {
        this.classList.remove('is-loading', 'is-added', 'is-error');
        if (nome) this.classList.add(nome);
        if (this.texto) this.texto.textContent = texto || this.textoOriginal;
      }

      adicionar(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.classList.contains('is-loading')) return;

        var self = this;
        clearTimeout(this.repor);
        this.estado('is-loading', 'A adicionar…');
        this.botao.setAttribute('aria-disabled', 'true');

        var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(this.botao.dataset.variantId, 10), quantity: parseInt(this.botao.dataset.quantidade, 10) || 1 }],
            sections: 'cart-icon-bubble,cart-drawer',
          }),
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok || data.status) throw new Error(data.description || data.message || 'Erro');
              return data;
            });
          })
          .then(function (data) {
            self.estado('is-added', tx('adicionado', 'Adicionado'));
            atualizarIconeCarrinho(data.sections);
            atualizarCarrinhoLateral(data.sections);
            mostrarAviso(data.items && data.items[0]);
            anunciar(tx('adicionadoAnuncio', 'Adicionado ao carrinho.'));
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bubbly-quick-add', productVariantId: self.botao.dataset.variantId });
            }
          })
          .catch(function (err) {
            self.estado('is-error', tx('erroAdicionar', 'Não foi possível adicionar'));
            anunciar(tx('erroAdicionarAnuncio', 'Não foi possível adicionar ao carrinho.') + ' ' + err.message);
          })
          .finally(function () {
            self.botao.removeAttribute('aria-disabled');
            self.repor = setTimeout(function () {
              self.estado(null);
            }, 2000);
          });
      }
    }
  );
})();
